import React from 'react';
import { Route } from 'react-router-dom';
import { getIsUserLoggedIn } from '../utils/cookie';
import { ROUTES } from '../constants';
import { redirectToPath } from '../utils/window';

function AuthRedirectRoute({ component: Component, ...rest }: Object) {
  return (
    <Route
      {...rest}
      render={(props: Object) =>
        getIsUserLoggedIn() ? (
          redirectToPath(ROUTES.PATH.ORDER_HISTORY)
        ) : (
          <Component {...props} />
        )
      }
    />
  );
}

export default AuthRedirectRoute;
